<template>
  <div class="drawer-content">
    <div class="action-categories">
      <!-- Self Entity -->
      <div v-if="!(trigger && trigger.is_global_action)" class="category-section">
        <div class="category-header">
          <i class="el-icon-user"></i>
          <h3>Self Entity</h3>
        </div>
        <div class="action-grid">
          <div
            v-for="(op, i) in enhancedSelfEntityOptions"
            :key="op.key + i"
            class="action-card professional-card"
            :class="op.cardClass"
            @click="selectAction(op.key)"
          >
            <div class="card-icon" :style="getIconStyle(op)">
              <i :class="op.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ op.label.replace('Self ', '') }}</h4>
              <p>{{ op.description }}</p>
            </div>
          </div>

          <!-- Additional Self Entity Actions -->
          <div class="action-card professional-card danger" @click="selectAction('self/DELETE')">
            <div class="card-icon" :style="getIconStyle(deleteAction)">
              <i :class="deleteAction.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ deleteAction.label }}</h4>
              <p>{{ deleteAction.description }}</p>
            </div>
          </div>

          <div
            v-if="currentEntity && currentEntity.entity_type === 'BUSINESS'"
            class="action-card professional-card"
            @click="selectAction('self/CREATE_CONTACT')"
          >
            <div class="card-icon" :style="getIconStyle(createContactAction)">
              <i :class="createContactAction.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ createContactAction.label }}</h4>
              <p>{{ createContactAction.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Other Entity -->
      <div v-if="!(trigger && trigger.is_global_action)" class="category-section">
        <div class="category-header">
          <i class="el-icon-s-management"></i>
          <h3>Other Entity</h3>
        </div>
        <div class="action-grid">
          <div
            v-for="(op, i) in enhancedOtherEntityOptions"
            :key="op.key + i"
            class="action-card professional-card"
            :class="op.cardClass"
            @click="selectAction(op.key)"
          >
            <div class="card-icon" :style="getIconStyle(op)">
              <i :class="op.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ op.label.replace('Other ', '') }}</h4>
              <p>{{ op.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- File Management -->
      <div class="category-section">
        <div class="category-header">
          <i class="el-icon-folder"></i>
          <h3>File Management</h3>
        </div>
        <div class="action-grid">
          <div
            v-for="action in fileManagementActions"
            :key="action.key"
            class="action-card professional-card"
            :class="action.cardClass"
            @click="selectAction(action.key)"
          >
            <div class="card-icon" :style="getIconStyle(action)">
              <i :class="action.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ action.label }}</h4>
              <p>{{ action.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Document Template -->
      <div
        v-if="
          !(trigger && trigger.is_global_action) &&
          currentEntity &&
          currentEntity.entity_type &&
          currentEntity.entity_type !== 'GENERAL'
        "
        class="category-section"
      >
        <div class="category-header">
          <i class="el-icon-document"></i>
          <h3>Document Template</h3>
        </div>
        <div class="action-grid">
          <div
            v-for="action in documentTemplateActions"
            :key="action.key"
            class="action-card professional-card"
            :class="action.cardClass"
            @click="selectAction(action.key)"
          >
            <div class="card-icon" :style="getIconStyle(action)">
              <i :class="action.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ action.label }}</h4>
              <p>{{ action.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Builder -->
      <div v-if="!(trigger && trigger.is_global_action)" class="category-section">
        <div class="category-header">
          <i class="el-icon-edit-outline"></i>
          <h3>Form Builder</h3>
        </div>
        <div class="action-grid">
          <div
            v-for="action in formBuilderActions"
            :key="action.key"
            class="action-card professional-card"
            :class="action.cardClass"
            @click="selectAction(action.key)"
          >
            <div class="card-icon" :style="getIconStyle(action)">
              <i :class="action.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ action.label }}</h4>
              <p>{{ action.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Calendar Event -->
      <div
        v-if="!(trigger && trigger.is_global_action) && currentEntity.schedulingConfiguration"
        class="category-section"
      >
        <div class="category-header">
          <i class="el-icon-date"></i>
          <h3>Calendar Event</h3>
        </div>
        <div class="action-grid">
          <div
            v-for="action in calendarActions"
            :key="action.key"
            class="action-card professional-card"
            :class="action.cardClass"
            @click="selectAction(action.key)"
          >
            <div class="card-icon" :style="getIconStyle(action)">
              <i :class="action.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ action.label }}</h4>
              <p>{{ action.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- External Source -->
      <div class="category-section">
        <div class="category-header">
          <i class="el-icon-link"></i>
          <h3>External Source</h3>
        </div>
        <div class="action-grid">
          <div
            class="action-card professional-card external"
            @click="selectAction(externalSourceAction.key)"
          >
            <div class="card-icon" :style="getIconStyle(externalSourceAction)">
              <i :class="externalSourceAction.icon"></i>
            </div>
            <div class="card-content">
              <h4>{{ externalSourceAction.label }}</h4>
              <p>{{ externalSourceAction.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { availableActions } from './AvailableActions';
  export default {
    name: 'ActionTypes',
    props: {
      block: Object,
      trigger: Object,
      currentEntity: Object,
    },
    data() {
      return {
        enhancedSelfEntityOptions: availableActions.enhancedSelfEntityOptions,
        enhancedOtherEntityOptions: availableActions.enhancedOtherEntityOptions,
        deleteAction: availableActions.deleteAction,
        createContactAction: availableActions.createContactAction,
        fileManagementActions: availableActions.fileManagementActions,
        documentTemplateActions: availableActions.documentTemplateActions,
        formBuilderActions: availableActions.formBuilderActions,
        calendarActions: availableActions.calendarActions,
        externalSourceAction: availableActions.externalSourceAction,
      };
    },
    methods: {
      getIconStyle(action) {
        return {
          backgroundColor: action.bgColor,
          color: action.color,
        };
      },
      selectAction(action) {
        this.$set(this.block, 'action', action);
        this.$emit('action-selected');
      },
    },
  };
</script>
<style scoped>
  .professional-drawer {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  .drawer-content {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
    background: linear-gradient(135deg, #f5f7fa 0%, #f0f2f5 100%);
  }

  .category-section {
    margin-bottom: 30px;
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    border: 1px solid #eaeaea;
  }

  .category-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f0f0f0;
  }

  .category-header i {
    font-size: 22px;
    color: #409eff;
    margin-right: 12px;
    background: #f0f7ff;
    padding: 8px;
    border-radius: 8px;
  }

  .category-header h3 {
    margin: 0;
    color: #303133;
    font-weight: 600;
    font-size: 18px;
  }

  .action-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
  }

  .action-card.professional-card {
    display: flex;
    flex-direction: column;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #eaeaea;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    background: white;
    position: relative;
    overflow: hidden;
  }

  .action-card.professional-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--card-accent, #409eff);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  .action-card.professional-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  }

  .action-card.professional-card:hover::before {
    transform: scaleX(1);
  }

  /* Card type styles */
  .action-card.professional-card.primary:hover {
    border-color: #409eff;
    --card-accent: #409eff;
  }

  .action-card.professional-card.success:hover {
    border-color: #67c23a;
    --card-accent: #67c23a;
  }

  .action-card.professional-card.warning:hover {
    border-color: #e6a23c;
    --card-accent: #e6a23c;
  }

  .action-card.professional-card.danger:hover {
    border-color: #f56c6c;
    --card-accent: #f56c6c;
  }

  .action-card.professional-card.info:hover {
    border-color: #909399;
    --card-accent: #909399;
  }

  .action-card.professional-card.whatsapp:hover {
    border-color: #25d366;
    --card-accent: #25d366;
  }

  .action-card.professional-card.external:hover {
    border-color: #909399;
    --card-accent: #909399;
  }

  .card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 12px;
    margin-bottom: 16px;
    transition: all 0.3s ease;
  }

  .action-card.professional-card:hover .card-icon {
    transform: scale(1.1);
  }

  .card-icon i {
    font-size: 24px;
  }

  .card-content h4 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
  }

  .card-content p {
    margin: 0;
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    opacity: 0.8;
  }

  /* Responsive adjustments */
  @media (max-width: 1200px) {
    .action-grid {
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }
  }

  @media (max-width: 768px) {
    .action-grid {
      grid-template-columns: 1fr;
    }

    .category-section {
      padding: 16px;
    }

    .category-header {
      margin-bottom: 16px;
    }
  }

  /* Custom scrollbar for drawer */
  .drawer-content::-webkit-scrollbar {
    width: 6px;
  }

  .drawer-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .drawer-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .drawer-content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* Animation for card entrance */
  @keyframes cardEntrance {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .action-card.professional-card {
    animation: cardEntrance 0.5s ease forwards;
  }

  /* Stagger animation for cards */
  .action-card.professional-card:nth-child(1) {
    animation-delay: 0.1s;
  }
  .action-card.professional-card:nth-child(2) {
    animation-delay: 0.15s;
  }
  .action-card.professional-card:nth-child(3) {
    animation-delay: 0.2s;
  }
  .action-card.professional-card:nth-child(4) {
    animation-delay: 0.25s;
  }
  .action-card.professional-card:nth-child(5) {
    animation-delay: 0.3s;
  }
</style>
